import listener from '@mailobj-browser/front/js/events/listeners/listener.js'
import preventDefault from '@mailobj-browser/front/js/events/hooks/preventDefault.js'
import click from '@mailobj-browser/front/js/events/types/click.js'
import object from '@mailobj-browser/front/js/utils/object.js'
import { insert } from '../rte.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import one from '@mailobj-browser/front/js/selectors/one.js'
import alert from '../../ea/alert.js'
import * as utilities from '#utilities/js/styles.js'

const onClick = object(listener, {
  type: click,
  hooks: array([
    preventDefault
  ]),
  task: async (
    button
  ) => {
    const { value, ownerDocument } = button
    const opener = one(`.${utilities.modifiers.lightbox.open}`, ownerDocument)
    const { id } = one('iframe[data-rte]', ownerDocument)

    if (id) {
      if (opener) {
        const text = value.replace('/\r/g', '\n')

        insert(id, `
          ${text}
        `)
      } else {
        const { dataset } = button
        const { alert: alertMsg } = dataset

        if (alertMsg) {
          await alert(alertMsg)
        }
      }
    }
  }
})

export default button => {
  onClick.listen(button)
}
